module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard"
  }, [_c('v-header', {
    attrs: {
      "name": _vm.name
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('v-bar')], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('v-line')], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('v-table')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('v-center', {
    attrs: {
      "positionTimes": _vm.positionTimes
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-291ee20d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/recordInformation/index.vue
// module id = 1967
// module chunks = 2